"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNdtrcDateTime = void 0;
const generateSingleNdtrcDateTime = (singleDate) => {
    const day = generateNdtrcDate(singleDate.date);
    const time = generateNdtrcTime(singleDate.when);
    return `${day}, ${time}`;
};
const generateNdtrcDateTime = (calendar) => {
    if (!calendar || !calendar.singleDates) {
        return { allDates: "", dateSummary: "" };
    }
    const allDates = calendar.singleDates
        .map((singleDate) => generateSingleNdtrcDateTime(singleDate))
        .join("\n");
    let dateSummary;
    if (calendar.singleDates.length === 1) {
        dateSummary = allDates;
    }
    else {
        dateSummary =
            calendar.singleDates.length > 0
                ? `${generateNdtrcDate(calendar.singleDates[0].date)} — ${generateNdtrcDate(calendar.singleDates[calendar.singleDates.length - 1].date)}`
                : "";
    }
    if ((calendar.calendarType === "PATTERNDATES" ||
        calendar.calendarType === "OPENINGTIMES") &&
        calendar.patternDates) {
        let startdate, enddate;
        startdate = calendar.patternDates
            .map((patternDate) => {
            return patternDate.startdate;
        })
            .sort()[0];
        enddate = calendar.patternDates
            .map((patternDate) => {
            return patternDate.enddate;
        })
            .sort()[calendar.patternDates.length - 1];
        dateSummary =
            calendar.patternDates.length > 0
                ? `${generateNdtrcDate(startdate)} — ${generateNdtrcDate(enddate)}`
                : "";
    }
    return { allDates: allDates, dateSummary: dateSummary };
};
exports.generateNdtrcDateTime = generateNdtrcDateTime;
const generateNdtrcDate = (date) => {
    if (!date) {
        return "???";
    }
    const dateTimeFormat = new Intl.DateTimeFormat("nl", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    const [{ value: day }, , { value: month }, , { value: year }] = dateTimeFormat.formatToParts(new Date(date));
    return `${year}-${month}-${day}`;
};
const generateNdtrcTime = (when) => {
    var _a, _b, _c;
    let time = "";
    if (when.length < 1) {
        return time;
    }
    if (when.length > 1) {
        return "Multiple time preview not yet implemented!";
    }
    // Force format to be "13:00" rather than "13:00:00"
    let timeslot = when[0];
    if (!timeslot.timestart) {
        time = "Whole day";
    }
    else if (!timeslot.timeend) {
        time += ((_a = timeslot.timestart.match(/[0-9]+:[0-9]+/)) === null || _a === void 0 ? void 0 : _a[0]) + "-";
    }
    else {
        time += `${(_b = timeslot.timestart.match(/[0-9]+:[0-9]+/)) === null || _b === void 0 ? void 0 : _b[0]}–${(_c = timeslot.timeend.match(/[0-9]+:[0-9]+/)) === null || _c === void 0 ? void 0 : _c[0]}`;
    }
    return time;
};
//# sourceMappingURL=dateHelper.js.map